/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDiamondFilled: {
  name: 'diamond-filled';
  data: string;
} = {
  name: 'diamond-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.523 1.903a1.552 1.552 0 0 0-.627.423c-.299.318-6.752 8.53-6.863 8.735a2.027 2.027 0 0 0 0 1.878c.124.23 6.593 8.451 6.897 8.767.109.113.3.257.424.32.206.104.263.114.646.114s.44-.01.646-.114a1.93 1.93 0 0 0 .424-.32c.304-.316 6.773-8.537 6.897-8.767a2.03 2.03 0 0 0 0-1.878c-.124-.23-6.593-8.451-6.897-8.767-.298-.308-.567-.426-1.01-.442-.258-.009-.41.006-.537.051"/></svg>`
};
